import { Injectable } from '@angular/core';
import {AbstractControl, ValidationErrors} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {
  emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z-A-Z]{2,4}$';
  namePattern = '^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+';
  surname1Pattern = '^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+';
  surname2Pattern = '^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+';
  phonePattern = '^[0-9]{9,15}';
  postalCodePattern = '^[a-zA-Z0-9-]{3,10}';
  nifPattern = '^(\\d{8})([A-Z])$';
  dniPattern = '^(\\d{8})$';
  niePattern = '^[XYZ]\\d{7,8}[A-Z]$';
  cifPattern = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
  cardPattern = /^[0-9]{8}$/;
  licensePattern = '^[A-Z]{1}-[0-9]{8}';
  biPattern = /^[0-9]{8}$/;
  documentDNI = '0';
  documentNIF = '1';
  documentNIE = '3';
  documentCIF = '2';
  documentLINCESE = '5';
  /** Dodcumentos para portugal **/
  documentCARD = '0';
  documentBI = '1';

  constructor() { }
  /*
    Algunas de las funciones de validacion se han extradido de este post: https://gist.github.com/afgomez/5691823
   */

  validateContribuyentNumber(value: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const contribuyentNumber = formGroup.get(value).value;
      this.resetShowErrorsMSG(formGroup, value);
      this.comprobarContribuyentNumber(formGroup, value, contribuyentNumber);
      return null;
    };
  }

  comprobarContribuyentNumber(formGroup: AbstractControl, input, value: any) {
    const number = typeof value === 'string' ? value : value.toString();
    const validationSets = {
      one: ['1', '2', '3', '5', '6', '8'],
      two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99']
    };
    if (number.length !== 9) {
      formGroup.get(input).setErrors({'contribuyentNumberFormatError': true});
    }
    if (!validationSets.one.includes(number.substr(0, 1)) && !validationSets.two.includes(number.substr(0, 2))) {
      formGroup.get(input).setErrors({'contribuyentNumberFormatError': true});
    }
    const total = number[0] * 9 + number[1] * 8 + number[2] * 7 + number[3] * 6 + number[4] * 5 + number[5] * 4 + number[6] * 3 + number[7] * 2;
    const modulo11 = (Number(total) % 11);
    const checkDigit = modulo11 < 2 ? 0 : 11 - modulo11;
    if (checkDigit === Number(number[8])) {
      return null;
    } else {
      formGroup.get(input).setErrors({'contribuyentNumberFormatError': true});
    }
  }

  validateDNI(campo1: string, campo2: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      // console.log( formGroup.value.tipoDocumento);
      const tipoDocumento = formGroup.get(campo1).value;
      const numeroDocumento = formGroup.get(campo2).value;
      // console.log(tipoDocumento, numeroDocumento);
      if ( tipoDocumento === this.documentDNI) {
        /*
       Para cuando cambiamos el tipo de documento eliminamos los errores para los mensajes
       y valide de nuevo
      */
        // console.log(formGroup.get(campo2).errors);
        this.resetShowErrorsMSG(formGroup, campo2);
        this.comprobarDNI(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
      }
      /** Comprobamos el documento NIF **/
        // console.log('Comprobamos el NIF');
      if ( tipoDocumento === this.documentNIF ) {
        /*
         Para cuando cambiamos el tipo de documento eliminamos los errores para los mensajes
         y valide de nuevo
        */
        // console.log(formGroup.get(campo2).errors);
        this.resetShowErrorsMSG(formGroup, campo2);
        this.comprobarNIF(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
      }



      /** Comprobamos el documento NIE **/
      if ( tipoDocumento === this.documentNIE ) {
        /*
        Para cuando cambiamos el tipo de documento eliminamos los errores para los mensajes
        y valide de nuevo
       */
        // console.log(formGroup.get(campo2).errors);
        this.resetShowErrorsMSG(formGroup, campo2);
        // console.log('Comprobamos el NIE');
        this.comprobarNIE(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
      }

      /** Comprobamos el documento CIF **/
      if ( tipoDocumento === this.documentCIF ) {
        /*
        Para cuando cambiamos el tipo de documento eliminamos los errores para los mensajes
        y valide de nuevo
       */
        // console.log(formGroup.get(campo2).errors);
        this.resetShowErrorsMSG(formGroup, campo2);
        // console.log('Comprobamos cif');
        this.comprobarCIF(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
      }
      /** Comprobamos el documento LICENCIA (Se activa cuando se realiza el check)**/

      if (tipoDocumento === this.documentLINCESE) {
        /*
        Para cuando cambiamos el tipo de documento eliminamos los errores para los mensajes
        y valide de nuevo
        */
        // console.log(formGroup.get(campo2).errors);
        this.resetShowErrorsMSG(formGroup, campo2);
        // console.log('Comprobamso la carta de Ciudadano');
        this.comprobarLicencia(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
      }
      return null;
    };
  }

  validarCamposPortugal(campo1: string, campo2: string) {
    return (formGroup: AbstractControl ): ValidationErrors | null => {
      const tipoDocumento = formGroup.get(campo1).value;
      const numeroDocumento = formGroup.get(campo2).value;
      // console.log(tipoDocumento, numeroDocumento);
      /*
        Validamos la carta del ciudadano
       */
      if (tipoDocumento === this.documentCARD) {
          // this.comprobarCard(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
          this.comprobarCitizenCard(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
      }
      /*
       Validamos BI (BILLETE DE IDENTIDAD)
      */
      if (tipoDocumento === this.documentBI) {
        //this.comprobarBI(tipoDocumento, numeroDocumento, formGroup, campo1, campo2);
      }
      return  null;
    };
  }
  comprobarDNI(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2) {
    if ( tipoDocumento === this.documentDNI ) {
        if ( numeroDocumento.match(this.dniPattern) ) {
            return null;
        } else {
          formGroup.get(campo2).setErrors({'dniFormatError': true});
        }
    }
  }

  comprobarNIF(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2) {
    /** Comprobamos que sea tipo NIF **/
    if ( tipoDocumento === this.documentNIF ) {
      /** Comprobamos que el numero de documento
       * sea disinto de null para comprobar la expresion regulsar
       */
      if (numeroDocumento != null) {
        if (numeroDocumento.match(this.nifPattern)) {
          /** Comprobamos la letra del NIF **/
          if (this.validDNI(numeroDocumento)) {
            // console.log('Es valido el NIF');
            return null;
          } else {
            formGroup.get(campo2).setErrors({'nifError': true});
          }
          // this.validDNI(numeroDocumento)
        } else {
          formGroup.get(campo2).setErrors({'nifFormatError': true});
        }
      }
    } else {
      // formGroup.get(campo2).setErrors({'DocumentoIncorrecto': true});
    }
  }

  comprobarNIE(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2 ) {
    /** Comprobamos el documento NIE **/
    if ( tipoDocumento === this.documentNIE ) {
      /** Comprobamos que el numero de documento
       * sea disinto de null para comprobar la expresion regulsar
       */
      if (numeroDocumento != null) {
        if (numeroDocumento.match(this.niePattern)) {
          /** Comprobamos la letra del DNI **/
          // console.log(numeroDocumento);
          if (this.validNIE(numeroDocumento)) {
            return null;
          } else {
            formGroup.get(campo2).setErrors({'nieError': true});
          }
          // this.validDNI(numeroDocumento)
        } else {
          formGroup.get(campo2).setErrors({'nieFormatError': true});
        }
      }
    } else {
      // formGroup.get(campo2).setErrors({'DocumentoIncorrecto': true})
    }
  }

  comprobarCIF(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2 ) {
    // console.log('Comprobar CIF');
    if ( tipoDocumento === this.documentCIF ) {
      if (numeroDocumento.match(this.cifPattern)) {
        const match = numeroDocumento.match(this.cifPattern);
        const letter = match[1];
        const number = match[2];
        const control = match[3];
        let even_sum = 0;
        let odd_sum = 0;
        let n;

        for ( let i = 0; i < number.length; i++) {
          n = parseInt( number[i], 10 );
          // Odd positions (Even index equals to odd position. i=0 equals first position)
          if ( i % 2 === 0 ) {
            // Odd positions are multiplied first.
            n *= 2;
            // If the multiplication is bigger than 10 we need to adjust
            odd_sum += n < 10 ? n : n - 9;
            // Even positions
            // Just sum them
          } else {
            even_sum += n;
          }
        }
        // @ts-ignore
        const control_digit = (10 - (even_sum + odd_sum).toString().substr(-1) );
        const control_letter: string = 'JABCDEFGHI'.substr( control_digit, 1 );
        // Control must be a digit
        if ( letter.match( /[ABEH]/ ) ) {
          // formGroup.get(campo2).setErrors({'cifDigitFormatError': true});
          // @ts-ignore
          // tslint:disable-next-line:triple-equals
          return control == control_digit;


          // Control must be a letter
        } else if ( letter.match( /[KPQS]/ ) ) {
          // formGroup.get(campo2).setErrors({'cifLetterFormatError': true});
          // tslint:disable-next-line:triple-equals
          return control == control_letter;

          // Can be either
        } else {
          // @ts-ignore
          // tslint:disable-next-line:triple-equals
          return control == control_digit || control == control_letter;
        }
      } else {
        formGroup.get(campo2).setErrors({'cifFormatError': true});
      }

    }
  }

  // comprobarCard(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2) {
  //   // console.log('Comprobar la carta de ciudado');
  //   // console.log(campo2);
  //   if ( tipoDocumento === this.documentCARD ) {
  //     // console.log(numeroDocumento);
  //     if (numeroDocumento.match(this.cardPattern)) {
  //       return null;
  //     } else {
  //       formGroup.get(campo2).setErrors({'cardFormatError': true});
  //     }
  //   }
  // }

  comprobarCitizenCard(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2) {
    return null;
    let sum = 0;
    let secondDigit = false;
    if (numeroDocumento.length != 12) {
      formGroup.get(campo2).setErrors({'cardFormatError': true});
    } else {
      for (let i = numeroDocumento.length - 1; i >= 0; --i) {
        let valor = this.getNumberFromChar(numeroDocumento[i]);
        if (secondDigit) {
          valor *= 2;
          if (valor > 9)
            valor -= 9;
        }
        sum += valor;
        secondDigit = !secondDigit;
      }
      if ((sum % 10) == 0) {
        return null;
      } else {
        formGroup.get(campo2).setErrors({'cardFormatError': true});
      }
    }
  }

  getNumberFromChar(letter) {
    switch (letter) {
      case '0':
        return 0;
      case '1':
        return 1;
      case '2':
        return 2;
      case '3':
        return 3;
      case '4':
        return 4;
      case '5':
        return 5;
      case '6':
        return 6;
      case '7':
        return 7;
      case '8':
        return 8;
      case '9':
        return 9;
      case 'A':
        return 10;
      case 'B':
        return 11;
      case 'C':
        return 12;
      case 'D':
        return 13;
      case 'E':
        return 14;
      case 'F':
        return 15;
      case 'G':
        return 16;
      case 'H':
        return 17;
      case 'I':
        return 18;
      case 'J':
        return 19;
      case 'K':
        return 20;
      case 'L':
        return 21;
      case 'M':
        return 22;
      case 'N':
        return 23;
      case 'O':
        return 24;
      case 'P':
        return 25;
      case 'Q':
        return 26;
      case 'R':
        return 27;
      case 'S':
        return 28;
      case 'T':
        return 29;
      case 'U':
        return 30;
      case 'V':
        return 31;
      case 'W':
        return 32;
      case 'X':
        return 33;
      case 'Y':
        return 34;
      case 'Z':
        return 35;
    }
  }

  comprobarBI(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2) {
    // console.log('Comprobar BI');
    // console.log(campo2);
    if ( tipoDocumento === this.documentBI ) {
      // console.log(numeroDocumento);
      if (numeroDocumento.match(this.biPattern)) {
        return null;
      } else {
        formGroup.get(campo2).setErrors({'cardFormatError': true});
      }
    }
  }

  comprobarLicencia(tipoDocumento: string, numeroDocumento: string, formGroup: AbstractControl, campo1, campo2) {
    const mustCheckLicense = localStorage.getItem('check_license');
    if ( tipoDocumento === this.documentLINCESE ) {
      if (mustCheckLicense === '1') {
        if (numeroDocumento.match(this.licensePattern)) {
          return null;
        } else {
          formGroup.get(campo2).setErrors({'licenseFormatError': true});
        }
      } else {
        if (numeroDocumento !== '') {
          return null;
        } else {
          formGroup.get(campo2).setErrors({'required': true});
        }
      }
    }
  }

  validDNI(dni) {
    const dni_letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const letter = dni_letters.charAt(parseInt(dni, 10) % 23);
    return letter == dni.charAt(8);
  }

  validNIE(nie) {
    let nie_prefix = nie.charAt(0);
    const letrasNIE = ['X', 'Y', 'Z'];
    nie_prefix = letrasNIE.indexOf(nie_prefix);
    const nieFormat = nie_prefix + nie.substr(1);
    return this.validDNI(nieFormat);

  }
  resetShowErrorsMSG(formGroup: AbstractControl, campo2) {
    if ( formGroup.get(campo2).errors ) {
      formGroup.get(campo2).setErrors(null);
    }
  }
}
